import { Bar, BarChart, ResponsiveContainer, XAxis, YAxis, Tooltip, Cell, CartesianGrid } from 'recharts'

interface MerchantChartProps {
  data: { merchant: string; amount: number }[]
  currencySymbol?: string
  onMerchantClick?: (merchant: string) => void
}

export function MerchantChart({ data, currencySymbol = '$', onMerchantClick }: MerchantChartProps) {
  if (data.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center h-[300px] text-muted-foreground gap-2">
        <p className="text-sm">No merchant data for this period</p>
        <p className="text-xs opacity-60">Add expenses with a merchant to see your top spends</p>
      </div>
    )
  }

  // Sort by amount desc and take top 5
  const sortedData = [...data].sort((a, b) => b.amount - a.amount).slice(0, 5)

  return (
    <ResponsiveContainer width="100%" height={300}>
      <BarChart data={sortedData} layout="vertical" margin={{ top: 5, right: 30, left: 10, bottom: 5 }}>
        <CartesianGrid strokeDasharray="3 3" horizontal={false} stroke="#E5E7EB" />
        <XAxis type="number" hide />
        <YAxis dataKey="merchant" type="category" width={100} tick={{ fontSize: 12, fill: '#6B7280' }} axisLine={false} tickLine={false} />
        <Tooltip
          formatter={(value) => [`${currencySymbol}${Number(value).toFixed(2)}`, 'Amount']}
          cursor={{ fill: 'transparent' }}
        />
        <Bar
          dataKey="amount"
          fill="#8884d8"
          radius={[0, 4, 4, 0]}
          barSize={32}
          onClick={onMerchantClick ? (data) => onMerchantClick((data as unknown as { merchant: string }).merchant) : undefined}
          style={{ cursor: onMerchantClick ? 'pointer' : 'default' }}
        >
          {sortedData.map((_entry, index) => (
            <Cell key={`cell-${index}`} fill={index % 2 === 0 ? '#8884d8' : '#82ca9d'} />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  )
}